import { render } from "./ExamPrerequisitesCard.vue?vue&type=template&id=4cf54a49&scoped=true"
import script from "./ExamPrerequisitesCard.vue?vue&type=script&lang=js"
export * from "./ExamPrerequisitesCard.vue?vue&type=script&lang=js"

import "./ExamPrerequisitesCard.vue?vue&type=style&index=0&id=4cf54a49&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf54a49"]])

export default __exports__